import React from 'react';
import classes from './style.module.css'
import { LEAGUE_TABLE_COLUMNS_ALL } from '../../../constants/Constants'
import ReactCountryFlag from "react-country-flag";
import LeagueDetailPopup from "../../../components/UI/LeagueDetailPopup"

const League = (props) => {
    const rowIndex = props.index + 1;
    const id = props.item.id;
    
    const columnList = props.finalColumns;

    const cells = columnList.map(column => {
        let cell = null; 
        const cellKey = id + "_" + column.id
        switch(column.id) {
            case LEAGUE_TABLE_COLUMNS_ALL.ROW_NUM.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{rowIndex}</th>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.COUNTRY_FLAG.id:
                const flag = props.item.countryCodeISO2 ? <ReactCountryFlag countryCode={props.item.countryCodeISO2} 
                cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                /> : null
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{flag}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.COUNTRY.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.country}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.LEAGUE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>
                    {props.item.league} 
                    <LeagueDetailPopup league={props.item.league} apiLeageId={props.item.apiLeageId} />
                </td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.MATCHES_PLAYED.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.matchesPlayed}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.WINS_HOME.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.winsHome}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.DRAWS.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.draws}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.WINS_AWAY.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.winsAway}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.GOALS.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.goals}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.GOALS_HOME.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.goalsHome}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.GOALS_AWAY.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.goalsAway}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.OVER_ONE_POINT_FIVE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.overOnePointFive}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.OVER_TWO_POINT_FIVE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.overTwoPointFive}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.OVER_THREE_POINT_FIVE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.overThreePointFive}</td>
            break;
            case LEAGUE_TABLE_COLUMNS_ALL.BTTS.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.btts}</td>
            break;
            default:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>UNKNOWN</td>
        } 
        return cell;
    })

    return (
        <tr className={classes.League}>
            {cells}
        </tr>           
    )
}

export default League;